module.exports = "/assets/data/572ad314608c696a4ea0a93422a6cc7c-BS22.data.json";